/* eslint max-len: ["error", 250] */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import FacebookProvider, { Login } from 'react-facebook'
import constant from '../../../constants'

export default class Facebook extends Component {
  responseFacebook = (response) => {
    this.props.onLoginResponse(response)
  }

  render() {
    return (
      <FacebookProvider appId={constant.FACEBOOK_APP_ID}>
        <Login scope="email" onResponse={this.responseFacebook}>
          <span
            className="join-with fb cursor-pointer xs-block xs-border-none xs-text-white xs-text-left xs-relative"
          >
            {this.props.buttonText}
            <svg
              className="xs-absolute xs-r4 xs-t4"
              width="27"
              height="27"
              viewBox="0 0 1792 1792"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759h-306v-759h-255v-296h255v-218q0-186 104-288.5t277-102.5q147 0 228 12z" fill="#fff" />
            </svg>
          </span>
        </Login>
      </FacebookProvider>
    )
  }
}

Facebook.propTypes = {
  onLoginResponse: PropTypes.func,
  buttonText: PropTypes.string,
}

Facebook.defaultProps = {
  onLoginResponse: PropTypes.func,
  buttonText: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/social/facebook/facebook.js